import Post from "./Post";
import React from "react";
import { activeDialog } from "./Common";
export default class Verifiers {
    static isEmail(email) {
        if (typeof email !== 'string' || email === null || email === undefined) {
            return false;
        }
        let emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailRegex.test(email);
    }
    static isPhone(phone) {
        if (typeof phone !== 'string' || phone === null || phone === undefined) {
            return false;
        }
        let phoneRegex = /^[0-9]{10}$/;
        return phoneRegex.test(phone);
    }
    static isName(name) {
        if (typeof name !== 'string' || name === null || name === undefined) {
            return false;
        }
        let nameRegex = /^[a-zA-Z\s]{3,}$/;
        return nameRegex.test(name);
    }
    static isPassword(password) {
        if (typeof password !== 'string' || password === null || password === undefined) {
            return false;
        }
        let passwordRegex = /^[a-zA-Z0-9]{8,}$/;
        return passwordRegex.test(password);
    }
    static text_normalice(cadena, upper = false) {
        if (typeof cadena !== 'string' || cadena.trim() === '') return "";

        // Mapa de caracteres especiales a alfanuméricos
        const map = {
            'á': 'a', 'Á': 'A',
            'é': 'e', 'É': 'E',
            'í': 'i', 'Í': 'I',
            'ó': 'o', 'Ó': 'O',
            'ú': 'u', 'Ú': 'U',
            'ñ': 'n', 'Ñ': 'N',
            'ä': 'a', 'Ä': 'A',
            'ë': 'e', 'Ë': 'E',
            'ï': 'i', 'Ï': 'I',
            'ö': 'o', 'Ö': 'O',
            'ü': 'u', 'Ü': 'U',
            'ç': 'c', 'Ç': 'C',
            'ß': 'ss',
            // Añade más reemplazos según sea necesario
        };

        // Reemplazar caracteres acentuados y especiales
        cadena = cadena.split('').map(char => map[char] || char).join('');

        // Eliminar espacios dobles
        cadena = cadena.replace(/\s+/g, ' ');

        // Eliminar caracteres no permitidos (excepto letras, números, guiones y espacios)
        cadena = cadena.replace(/[^a-zA-Z0-9\- ]/g, '');

        // Convertir a minúsculas o mayúsculas
        cadena = upper ? cadena.toUpperCase() : cadena.toLowerCase();

        return cadena.trim();
    }

    static sortByAttribute(array, attributeName, ascending = true, isDate = false) {
        if (!Array.isArray(array) || typeof attributeName !== 'string') {
            return array;
        }
        return array.sort((a, b) => {
            let valueA = a[attributeName];
            let valueB = b[attributeName];

            let comparison = 0;

            if (isDate) {
                // Check if values are dates
                let dateA = new Date(valueA);
                let dateB = new Date(valueB);
                let isDateA = !isNaN(dateA.getTime());
                let isDateB = !isNaN(dateB.getTime());
                comparison = dateA - dateB;
            } else if (typeof valueA === 'string' && typeof valueB === 'string') {
                comparison = valueA.localeCompare(valueB);
            } else {
                comparison = valueA - valueB;
            }

            return ascending ? comparison : -comparison;
        });
    }

    static isoToMySQL(isoDate) {
        try {
            const date = new Date(isoDate);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
                return "";
            }
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        } catch (error) {
            return "";
        }
    }

    /**
     * Transforma una fecha en formato 'YYYY-MM-DD HH:MM:SS' a 'YYYY-MM-DDTHH:MM'
     * @param {string} mysqlDate - La fecha en formato MySQL 'YYYY-MM-DD HH:MM:SS'
     * @returns {string} - La fecha en formato ISO 'YYYY-MM-DDTHH:MM'
     */
    static mySQLToISO(mysqlDate) {
        try {
            const [datePart, timePart] = mysqlDate.split(' ');
            const [year, month, day] = datePart.split('-');
            const [hours, minutes] = timePart.split(':');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        } catch (error) {
            return "";
        }

    }

    static extraerBloquesUnicos = (cadena, normalice = false) => {
        if (typeof cadena !== 'string' || cadena.length < 1) return [];
        if (normalice) cadena = this.text_normalice(cadena);
        let data = [];
        let len = cadena.length;
        let palabra = "";

        for (let i = 0; i < len; i++) {
            let letra = cadena.charAt(i);
            if (i === len - 1) {
                if (letra !== ' ') palabra += letra;
                if (palabra !== '') data.push(palabra);
            } else if (letra === ' ') {
                if (palabra.length > 0) {
                    data.push(palabra);
                    palabra = '';
                }
            } else {
                palabra += letra;
            }
        }

        data = [...new Set(data)];

        return data;
    }

    //verifica que una cadena de texto contenga todas las subcadenas contenidas en el array elementos
    static elementosEnCadena = (cadena, elementos) => {
        if (typeof cadena !== 'string' || cadena.length < 1 || !Array.isArray(elementos) || elementos.length < 1) return false;
        let len = elementos.length;
        for (let i = 0; i < len; i++) {
            if (!cadena.includes(elementos[i])) return false;
        }

        return true;
    }

    static getDataAPI = async (uri, data = {}, setloader = false, setDialog = false, method = 'POST') => {
        let resp = await Post(uri, data, method, setloader);
        if (!resp.estatus && setDialog) {
            activeDialog(setDialog, resp.msj, 'error', 'error');
            return false;
        }
        return resp;
    }

    static text_normalice(cadena, upper = false) {
        if (typeof cadena !== 'string' || cadena.trim() === '') return "";

        // Mapa de caracteres especiales a alfanuméricos
        const map = {
            'á': 'a', 'Á': 'A',
            'é': 'e', 'É': 'E',
            'í': 'i', 'Í': 'I',
            'ó': 'o', 'Ó': 'O',
            'ú': 'u', 'Ú': 'U',
            'ñ': 'n', 'Ñ': 'N',
            'ä': 'a', 'Ä': 'A',
            'ë': 'e', 'Ë': 'E',
            'ï': 'i', 'Ï': 'I',
            'ö': 'o', 'Ö': 'O',
            'ü': 'u', 'Ü': 'U',
            'ç': 'c', 'Ç': 'C',
            'ß': 'ss',
            // Añade más reemplazos según sea necesario
        };

        // Reemplazar caracteres acentuados y especiales
        cadena = cadena.split('').map(char => map[char] || char).join('');

        // Eliminar espacios dobles
        cadena = cadena.replace(/\s+/g, ' ');

        // Eliminar caracteres no permitidos (excepto letras, números, guiones y espacios)
        cadena = cadena.replace(/[^a-zA-Z0-9\- ]/g, '');

        // Convertir a minúsculas o mayúsculas
        cadena = upper ? cadena.toUpperCase() : cadena.toLowerCase();

        return cadena.trim();
    }

    static getUniqueWords(string, normalice = false) {
        if (typeof string !== 'string' || string.trim() === '') {
            return [];
        }
        if (normalice) string = this.text_normalice(string, true);
        let words = string.split(' ');
        let uniqueWords = [...new Set(words)];
        return uniqueWords;
    }

    /**
    * Chaeck if the all strings in the arrray words are included in the text
    * @param {List} words list of string to find
    * @param {string} text text to search the words are included
    * @returns 
    */
    static find(words, text) {
        let len = words.length;
        for (let j = 0; j < len; j++) {
            if (!text.includes(words[j])) return false;
        }
        return true;
    }


    /**
      * Retorna las diferencias en semanas entre la semana de siembra planeada y la semana de ejecución
      * @param {object} p - un elemento del plan de siembra de la lista alojada en data
      * @returns {number} numero de semanas de diferencia respecto a semana de siembra planeada
      */
    static diferencia = (p) => {
        if (p.semana_ejecucion && p.fecha_inicio) {
            let inicio = new Date(p.fecha_inicio);
            let ejecucion = new Date(p.fecha_semana_ejecucion);

            let diferencia = ejecucion - inicio;
            let dias = diferencia / (1000 * 60 * 60 * 24);
            let semanas = dias / 7;
            return Math.floor(semanas);
        }
        return 0;
    }

    /**
     * 
     * @param {string} originalValue cadena de texto que puede o no contener un numero
     * @param {any} defaultValue Si la cadena no contiene un numero, se retorna este valor, si este valor no se proporciona retnroa nulo
     * @returns muber | defaultValue
     */
    static numberParser = (originalValue, defaultValue = null) => {
        try {
            let value = parseFloat(originalValue);
            if (isNaN(value)) {
                return defaultValue;
            }
            return value;
        } catch (error) {
            return defaultValue;
        }
        ;
    }

    /**
     * Maneja el estado del dialogo, pensado para usarse con hook de los dao¿tos que se pasan al componente VAINILLA DIALOG
     * @param {function} setdialog funcion de estado para activar le hook dialogo
     * @param {string} info Cuando se activa el dialogo, este es el mensaje que se muestra
     * @param {string} type Nombrre del tipo de dialogo, por defecto es 'error' pero puede ser 'success' o 'warning' o 'error'
     * @param {string} head Tittulo del dialogo
     * @returns 
     */
    static activeDialog = (setdialog, info, head = "Ocurrió un problema", type = "error") => {
        if (!setdialog) return;
        setdialog({
            tipo: type,
            show: true,
            title: head,
            body: info ?? "",
            funct: () => { setdialog({ show: false }) },
            size: 'm'
        })
    }

    /**
     * utiliza un identificador para buscarlo en el DOM y hacer scroll hacia el tras una pausea de x cantida de milisegundos
     * @param {string} id identificador del elemento hacia donde se desea hacer scroll
     * @param {number} ms tiempo de espera antes de hacer scroll
     * @param {string} containerId identificador del contenedor que se desea hacer scroll, si no se proporciona se hace scroll en el body
     */
    static scrollAnimacion = (id, ms = 200, containerId = null) => {
        setTimeout(() => {
            let elemento = document.getElementById(id);
            if (elemento) {
                if (containerId) {
                    let contenedor = document.getElementById(containerId);
                    if (contenedor) {
                        const elementPosition = elemento.getBoundingClientRect().top;
                        const containerPosition = contenedor.getBoundingClientRect().top;
                        const offsetPosition = elementPosition - containerPosition + contenedor.scrollTop;

                        contenedor.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth"
                        });
                    }
                } else {
                    elemento.scrollIntoView({ behavior: "smooth" });
                }
            }
        }, ms);
    }

    /**
     * convierte un dato a su formato numerico, si no es posible tranformarlo retorna un valor por defecto
     * @param {any} number valor a verificar si es un numero
     * @param {number} dafeultNumber valor a retornar si el valor no es un numero, por defecto es cero
     * @returns {number} el valor numerico o el valor por defecto
     */
    static numberFormat = (number, dafeultNumber = 0) => {
        try {
            let format = parseFloat(number);
            if (isNaN(format)) return dafeultNumber;
            return format;
        } catch (error) {
            return dafeultNumber;
        }
    }

    /**
 * Guarda un dato en el Local Storage.
 * @param {string} key - La clave bajo la cual se almacenará el dato.
 * @param {*} data - El dato que se va a almacenar. Será convertido a una cadena JSON.
 * @returns {boolean} - Retorna true si el dato se guardó correctamente, false en caso de error.
 */
    static saveLS = (key, data) => {
        try {
            let dataToSave = JSON.stringify(data);
            localStorage.setItem(key, dataToSave);
        } catch (error) {
            if (typeof key === "string") {
                this.deleteLS(key);
            }
            return false;
        }
        return true;
    }

    /**
     * Elimina un dato del Local Storage.
     * @param {string} key - La clave del dato que se va a eliminar.
     * @returns {boolean} - Retorna true si el dato se eliminó correctamente, false en caso de error.
     */
    static deleteLS = (key) => {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            return false;
        }
        return true;
    }

    /**
     * Obtiene un dato del Local Storage.
     * @param {string} key - La clave del dato que se va a obtener.
     * @returns {*} - Retorna el dato almacenado, o null si no se encuentra o si ocurre un error.
     */
    static getLS = (key) => {
        if (typeof key === 'string') {
            try {
                let data = localStorage.getItem(key);
                if (!data) return null;
                return JSON.parse(data);
            } catch (error) {
                return null;
            }
        }
    }

    /**
     * retorna un Object con los estilos necesarios para que un componente se posiciones sobre el reto
     * @param {number} zIndex 
     * @returns {Object} con la forma {overflow: "auto", zIndex: zIndex, position: "fixed", top: 0, left: 0}
     */
    static floatPageStyle = (zIndex = 1000) => {
        return { overflow: "auto", zIndex: zIndex, position: "fixed", top: 0, left: 0 };
    }

    static divisorHTML = (key = null, height = 0) => <div className='w-100' style={{ height: height }} key={key ?? this.keyGen()} />;
    static keySeed = 0;

    static keyGen() {
        this.keySeed++;
        return this.keySeed;
    }

    static screenDimentions = () => {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }

    /**
     * Adds an event listener to the window resize event and calls the provided state function with the new screen dimensions.
     * @param {Function} setState - The state function to call with the new screen dimensions.
     */
    static onScreenResize(setState) {
        const handleResize = () => {
            setState({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);

        // Call the handler immediately to set the initial state
        handleResize();

        // Return a function to remove the event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }

    static changeMaxHeight = (screen, height, changes) => {
        if (changes.length === 0) return "83vh";
        let changeslen = changes.length;
        for (let i = 0; i < changeslen; i++) {
            if (i === changeslen - 1) return changes[i][1] + "vh";
            if (height > changes[i][0]) continue;
            return changes[i][1] + "vh";
        }
    }

    static maxHeight = (screen, height = 780, width = 1200, startVH = 80, changes = .3) => {

        if (screen.width < width || screen.height < height) {
            console.log("pantalla 100%");
            return "100%";
        }
        let minHeight = startVH;
        let newHeight = 0;
        let vhHeight = "100%";
        for (let i = 0; i < 30 && newHeight < screen.height; i++) {
            let extra = i * 10 * (1 + (i * changes));
            let portion = 50 + extra;
            newHeight = 780 + extra + portion;
            vhHeight = `${minHeight + i}vh`;
            //console.log(`portion: ${i} ° extra:${+extra.toFixed(1)}  portion:${+portion.toFixed(1)} ° newheight:${+newHeight.toFixed(1)} ${minHeight + i}vh`);
        }
        // console.log(`_________________________________________`, vhHeight);
        return vhHeight;
    }

    /**Determina si una semana recibida tiene o no el formato Floricents, devuelve un string si es correcta o null si no lo es */
    static semanaFloricents = (semana) => {
        if (typeof semana !== 'string' && typeof semana !== 'number') return null;

        const semanaString = `${semana}`;
        if (semanaString.length !== 4) return null;

        const anio = semanaString.substring(0, 2);
        const semanaNum = semanaString.substring(2, 4);
        if (isNaN(parseInt(anio)) || isNaN(parseInt(semanaNum))) return null;
        if (+anio < 20) return null;
        if (+semanaNum < 1 || +semanaNum > 53) return null;
        return semanaString;
    }

    static int = (value, min = null, max = null) => {
        if (value === null || value === undefined) return false;

        let intValue = parseInt(value);
        if (isNaN(intValue)) return false;

        if (min !== null && intValue < min) return false;
        if (max !== null && intValue > max) return false;
        return intValue;
    }

    static float = (value, min = null, max = null) => {
        if (value === null || value === undefined) return false;
        let floatValue = parseFloat(value);
        if (isNaN(floatValue)) return false;

        if (min !== null && floatValue < min) return false;
        if (max !== null && floatValue > max) return false;
        return floatValue;
    }
}